import { gdprCountries } from '@chegg/one-auth';

export { setCountry };

function setCountry(newCountry: string) {
  const country = newCountry.toUpperCase();

  if (country && gdprCountries[country]) {
    return country;
  }
}
